import { ReactNode } from "react";
import { NavLink } from "react-router";
import {
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/shared/components/ui/breadcrumb";
import t from "@/lang/lang";
import { RltBreadcrumbs } from "@/routes/processes/[processId]/rlt/_components/rlt-breadcrumbs";
import { ReferenceNumber } from "@/services/backend/documents/components/reference-number";
import { WorkOrder } from "@/services/backend/rlt/work-orders/types/work-order";

/**
 * WorkOrderBreadcrumbs renders the full-depth breadcrumb trail for a work-order
 * detail page: Customer > Process > Arbeitsscheine > <sub-milestone> > <Dok-Nr>.
 * `segment` is the sub-milestone URL segment (planning/execution/completion) and
 * `children` is its label.
 */
export function WorkOrderBreadcrumbs({
  workOrder,
  segment,
  children,
}: {
  workOrder: WorkOrder;
  segment: "planning" | "execution" | "completion";
  children: ReactNode;
}) {
  return (
    <RltBreadcrumbs
      customerId={workOrder.customerId}
      processId={workOrder.processId!}
    >
      <BreadcrumbSeparator />
      <BreadcrumbItem className="hidden md:block">
        <BreadcrumbLink asChild>
          <NavLink to={`/processes/rlt/${workOrder.processId!}/work-orders`}>
            {t("Arbeitsscheine")}
          </NavLink>
        </BreadcrumbLink>
      </BreadcrumbItem>
      <BreadcrumbSeparator />
      <BreadcrumbItem className="hidden md:block">
        <BreadcrumbLink asChild>
          <NavLink
            to={`/processes/rlt/${workOrder.processId!}/work-orders/${segment}`}
          >
            {children}
          </NavLink>
        </BreadcrumbLink>
      </BreadcrumbItem>
      <BreadcrumbSeparator />
      <BreadcrumbItem>
        <BreadcrumbPage>
          <ReferenceNumber referenceNumber={workOrder.referenceNumber} />
        </BreadcrumbPage>
      </BreadcrumbItem>
    </RltBreadcrumbs>
  );
}
